// this function format like this January 31, 2025 at 20:41 hours
export function formatCurrentDate(): string {
  const currentDate = new Date();

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(
    currentDate,
  );

  return `${formattedDate}`;
}

// this function formate like this April 12, 2025
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return '';
  }
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return date.toLocaleDateString('en-US', options);
}

// this function formate like this 07 Feb 2025, 14:30 EST

export function formatDateToEST(dateString: string): string {
  const date = new Date(dateString);

  const formattedDate = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/New_York', // Set the timezone to EST
  }).format(date);

  return formattedDate;
}
